import { Directive, HostListener,  Renderer2, RendererFactory2, Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PortalService, RoutingService, SecurityService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';
import moment from 'moment';
import reportFeatureName from 'src/app/models/reportfeaturename.json';

export class PendingLogRequest {
  _url: string;
  _method: string;
  _options: any;
  _data: any;

  constructor(url: string, method: string, options: any, data: any) {
    this._url = url;
    this._method = method;
    this._options = options;
    this._data = data;
  }
}

@Injectable({ providedIn: 'root' })
export class MasterLogService {
  private requests$ = new Subject<any>();
  private queue: PendingLogRequest[] = [];
  private renderer: Renderer2;
  private IsTokenRetriveInProcess: boolean = false;
  private MessagePostingInProcess: boolean = false;
  private TokenRetriveRetryCount: number = 0;
  private MessagePostRetryCount: number = 0;
 
  constructor(private httpClient: HttpClient, private routingService: RoutingService, private securityService: SecurityService, private rendererFactory: RendererFactory2, private portalService: PortalService) {
    //this.getToken().then(() => { });
    this.requests$.subscribe((request) => {
      this.execute(request);
    });
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /** Call this method to add your http request to queue */
  invoke(params: any, options: any) {
   if(environment.enableMasterLog == true){
      this.addRequestToQueue(params, options);
    }
      
  }

  postLogMessage(action: string, message: string, featureName: string | null = null, pageName: string | null = null) {
try{
    let userInfo = this.securityService.currentUserValue;
    featureName = (featureName != undefined && featureName != null && featureName !='' ) ? featureName?.charAt(0).toUpperCase() + featureName?.slice(1) : null;
    pageName = (pageName != undefined && pageName != null && pageName !='' ) ? pageName?.charAt(0).toUpperCase() + pageName?.slice(1) : null;
    var masterlogData = {
      "PlatformID": <number>Helpers.getPlatformId(),
      "PageName":(this.routingService.getPageName() == this.portalService.portalConfiguation?.value.SponsorName) ? "Dashboard" :
      (this.routingService.getPageName() == this.portalService.portalConfiguation?.value.PortalName) ? this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1) :
       (!Helpers.isNullOrUndefined(pageName) && pageName != "") ? pageName : this.routingService.getPageName() != "" ? this.routingService.getPageName().charAt(0).toUpperCase() + this.routingService.getPageName().slice(1) : this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1),
      "FeatureName": (this.routingService.getFeatureName() == this.portalService.portalConfiguation?.value.PortalName) ? "Dashboard" :
      (!Helpers.isNullOrUndefined(featureName) && featureName != "") ? featureName :this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1),
      "Action": action,
      "DateTime": moment().utc(),
      "UserId": userInfo.UserGuid,
      "Message": message,
      "SessionId": userInfo.SessionId,
      "Organization":this.portalService.portalConfiguation?.value.SponsorName != undefined ? this.portalService.portalConfiguation?.value.SponsorName : null,
      "SubOrganization":this.portalService.portalConfiguation?.value.PortalName != undefined ? this.portalService.portalConfiguation?.value.PortalName : null
    };
  }
  catch (e) {
    console.log(e);
  }
    setTimeout(() => {
      this.invoke(masterlogData, {});
    }, 1000);
   
  }

  private async execute(requestData: PendingLogRequest) {
 
    if (requestData != null && environment.enableMasterLog == true) {
      //One can enhance below method to fire post/put as well. (somehow .finally is not working for me)
      var token = await this.getToken();//.then((token) => {
      if (token != null) {
        if (!this.MessagePostingInProcess && this.MessagePostRetryCount < 5) {
          console.log("total queue length : ", this.queue.length, " current req message : ", requestData._data["Message"]);
          this.MessagePostingInProcess = true;
          const headers = new HttpHeaders({ 'Authorization': <string>token, 'Content-Type': 'application/x-www-form-urlencoded' });
          this.httpClient.post(requestData._url, requestData._data, { headers: headers }).toPromise()
            .then((res) => {
              this.MessagePostingInProcess = false;
              this.MessagePostRetryCount = 0;
              this.startNextRequest();
            }).catch((error: any) => {
              setTimeout(() => {
                this.MessagePostingInProcess = false;
                this.MessagePostRetryCount += 1;
                this.execute(requestData);
              }, 5000);
            });
        }
      } else {
        this.MessagePostingInProcess = false;
        this.MessagePostRetryCount = 0;
        this.execute(requestData);
      }
    }
  }

  private addRequestToQueue(params: any, options: any) {
    const request = new PendingLogRequest(environment.masterLogEndPoint, "post", options, params);
    this.queue.push(request);
    if (!this.MessagePostingInProcess)
      this.startNextRequest();
  }

  private getToken(): Promise<string | null> {
    return new Promise((tokenResponse) => {
      if (localStorage.getItem("LogToken") != undefined && !this.IsTokenRetriveInProcess) {
        const token = <string>localStorage.getItem("LogToken");
        try {
          const timeStamp: number = parseInt(<string>Helpers.getQueryParamValue(token, "se"));
          if (moment().isBefore(moment.unix(timeStamp)))
            tokenResponse(token);
          else {
            localStorage.removeItem("LogToken");
            this.TokenRetriveRetryCount -= 1;
            tokenResponse(null);
          }
        } catch (e) {
          console.log(e);
          this.TokenRetriveRetryCount -= 1;
          tokenResponse(null);
        }
      } else if (!this.IsTokenRetriveInProcess) {
        this.IsTokenRetriveInProcess = true;
        if (this.TokenRetriveRetryCount < 10) {
          this.httpClient.post(environment.masterLogTokenGenerateEndPoint, "").toPromise()
            .then((res: any) => {
              this.IsTokenRetriveInProcess = false;
              localStorage.setItem("LogToken", res);
              this.TokenRetriveRetryCount = 0;
              tokenResponse(res);
            }).catch((error: any) => {
              setTimeout(() => {
                this.IsTokenRetriveInProcess = false;
                this.TokenRetriveRetryCount += 1;
                tokenResponse(null);
              }, 5000);
            });
        }
      }
    });
  }

  private startNextRequest() {
    // get next request, if any.
    if (this.queue.length > 0) {
      //console.log(this.queue[0]._data["Message"]);
      const currentRequest = this.queue.shift()!;
      //console.log(currentRequest._data["Message"]);
      this.execute(currentRequest);
    }
  }
 
}

@Directive({
    selector: '[medptevlog]',
    standalone: false
})
export class MedptEventLogDirective implements OnDestroy {
  sub: Subscription;
  extentedFeatureName !:string;
  extentedPageName !: string;
  reportFeatureId !:any;
  constructor(private router: Router, private masterLogService: MasterLogService, private routingService: RoutingService, private securityService: SecurityService, private portalService: PortalService,) {
    this.sub = this.router.events.subscribe((value) => {
      if (value instanceof NavigationEnd || value instanceof NavigationStart) {
        //setTimeout(() => {//});      
        if ((value["url"].split("?")[0] != this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString().split("?")[0])) {
          this.reportFeatureId = this.router.url.split("rpt=").pop()?.substring(0,3).replace('&','');
           if (value instanceof NavigationEnd && this.routingService.getFeatureName() != '') {
            setTimeout(() => {
              var message =  this.routingService.getFeatureName() == 'VerifySite' ? this.routingService.getPageName().charAt(0).toUpperCase() + this.routingService.getPageName().slice(1) :this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1);
              this.postLogMessage("View", message + " Loads");
            },1000)
          } else if (value instanceof NavigationStart && this.routingService.getFeatureName() != '') {
            var message = this.routingService.getFeatureName() == this.portalService.portalConfiguation?.value.PortalName ? 'My View' : 
            this.routingService.getFeatureName() == 'VerifySite' ? this.routingService.getPageName().charAt(0).toUpperCase() + this.routingService.getPageName().slice(1) :this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1);
            this.postLogMessage("Exit", "End " + message);
          }
        }
      }
    });
  }
    ngOnDestroy(): void {
      this.sub.unsubscribe();     
    }

  @HostListener('click', ["$event"])
  onClick($event: Event) {
    if ($($event.target!).attr('medpt-log-message') || <string>$($event.target!).attr('medpt-log-action')) {
      this.postLogMessage(<string>$($event.target!).attr('medpt-log-action'), <string>$($event.target!).attr('medpt-log-message'));
    }
  }

  private postLogMessage(action: string, message: string) {
    let userInfo = this.securityService.currentUserValue;
    let FeatureNameOfReport =this.reportFeatureId !=undefined? reportFeatureName.filter(x => x.FeatureId == this.reportFeatureId) : null;
  try{
    var masterlogData = {
      "PlatformID": <number>Helpers.getPlatformId(),
      "PageName": (this.routingService.getPageName() == this.portalService.portalConfiguation?.value.SponsorName) ? "Dashboard" :
      (this.routingService.getPageName() == this.portalService.portalConfiguation?.value.PortalName) ? this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1) :
      this.routingService.getPageName() != "" ? this.routingService.getPageName().charAt(0).toUpperCase() + this.routingService.getPageName().slice(1) : this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1),
      "FeatureName": (this.routingService.getFeatureName() == this.portalService.portalConfiguation?.value.PortalName) ? "Portal Dashboard" :
        (this.routingService.getPageName() == this.portalService.portalConfiguation?.value.PortalName) && FeatureNameOfReport != undefined && FeatureNameOfReport.length > 0 ? 
      FeatureNameOfReport[0].FeatureName.charAt(0).toUpperCase() + FeatureNameOfReport[0].FeatureName.slice(1): this.routingService.getFeatureName().charAt(0).toUpperCase() + this.routingService.getFeatureName().slice(1) ,
      "Action": action,
      "DateTime": moment().utc(),
      "UserId": userInfo.UserGuid,
      "Message": message,
      "SessionId": userInfo.SessionId,
      "Organization":this.portalService.portalConfiguation?.value.SponsorName != undefined ? this.portalService.portalConfiguation?.value.SponsorName : null,
      "SubOrganization":this.portalService.portalConfiguation?.value.PortalName != undefined ? this.portalService.portalConfiguation?.value.PortalName : null
    };
    this.masterLogService.invoke(masterlogData, {});
  }
  catch (e) {
    console.log(e);
  }
    
  }
}
